export default "__VITE_ASSET__24230100__"